import { createSlice } from '@reduxjs/toolkit';
import reducers from 'src/redux/user-management/reducers';
import { userListInitialState } from './types';

const usersSlice = createSlice({
  name: 'user-management',
  initialState: userListInitialState,
  reducers,
});

export const {
  updateBlockOutTimeSource,
  modifyBlockOutTime,
  removeItemFromAgendaList,
  updateTechnicianTimezone,
} = usersSlice.actions;

export default usersSlice.reducer;
